module.exports = __webpack_public_path__ + "img/4.ae23485c.jpg";